import { useRef, useState } from "react";
import FloatingMenu from "./FloatingMenu";

export type Option = { value: string | number; label: string };

export default function IconListDropdown({
  title,
  iconClass,
  options,
  multiple = false,
  value,
  onChange,
  btnClassName = "btn btn-link",
  menuMaxHeight = 280
}: {
  title: string;
  iconClass: string;
  options: Option[];
  multiple?: boolean;
  value?: any;
  onChange: (val: any) => void;
  btnClassName?: string;
  menuMaxHeight?: number;
}) {
  const [open, setOpen] = useState(false);
  const btnRef = useRef<HTMLButtonElement>(null);

  const hasSelection = multiple
    ? Array.isArray(value) && value.length > 0
    : value !== undefined && value !== null && value !== "";

  const toggleItem = (optValue: string | number) => {
    if (multiple) {
      const arr = Array.isArray(value) ? [...value] : [];
      const idx = arr.findIndex((v) => String(v) === String(optValue));
      if (idx >= 0) arr.splice(idx, 1);
      else arr.push(optValue);
      onChange(arr);
    } else {
      onChange(String(value) === String(optValue) ? undefined : optValue);
      setOpen(false);
    }
  };

  return (
    <>
      <button
        ref={btnRef}
        type="button"
        className={`${btnClassName} ${hasSelection ? "text-primary" : ""}`}
        title={title}
        onClick={() => setOpen((v) => !v)}
      >
        <i className={iconClass} />
      </button>

      <FloatingMenu
        anchorRef={btnRef}
        open={open}
        onClose={() => setOpen(false)}
      >
        <div
          className="dropdown-menu show p-2 shadow-sm"
          style={{
            position: "static",
            minWidth: 220,
            maxHeight: menuMaxHeight,
            overflowY: "auto"
          }}
        >
          <div className="small text-muted px-1 mb-1">{title}</div>
          <ul className="list-unstyled mb-0">
            {options.map((opt) => {
              const checked = multiple
                ? Array.isArray(value) &&
                  value.some((v: any) => String(v) === String(opt.value))
                : String(value) === String(opt.value);

              const isNone = String(opt.value) === "__none__";

              return (
                <li
                  key={String(opt.value)}
                  className="d-flex align-items-center py-1 px-1 rounded hover-bg"
                  style={{ cursor: "pointer" }}
                  onClick={() => toggleItem(opt.value)}
                >
                  {!isNone &&
                    (multiple ? (
                      <input
                        type="checkbox"
                        className="form-check-input me-2"
                        readOnly
                        checked={checked}
                      />
                    ) : (
                      <input
                        type="radio"
                        name={`icon-list-${title}`}
                        className="form-check-input me-2"
                        readOnly
                        checked={checked}
                      />
                    ))}
                  <span className={isNone ? "text-muted " : ""}>
                    {opt.label}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
      </FloatingMenu>
      <style>{`
        .hover-bg:hover { background: rgba(0,0,0,0.04); }
      `}</style>
    </>
  );
}
